var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f-bs4",staticStyle:{"display":"none"},attrs:{"id":"f-nav","data-turbo-permanent":""}},[_c('Nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }